import React from "react";
import NumberFormat from "react-number-format";
import { cleanCpfCnpj, maskCnpjAlfanumerico } from "helpers/string";

export default function NumberFormatCustom(props) {
	const { inputRef, placeholder, type, input, meta, ...other } = props;

	const { onChange, ...rest } = input || {};

	const { touched, error } = meta || {};

	return (
		<span className="form__form-group-input-wrap">
			<NumberFormat
				{...other}
				{...rest}
				getInputRef={inputRef}
				placeholder={placeholder}
				type={type}
				onValueChange={values => {
					onChange && onChange(values.value);
				}}
			/>
			{((touched && error) || props.errors) && (
				<span className="form__form-group-error">{error || props.errors}</span>
			)}
		</span>
	);
}

export function NumberFormatCustomFloat(props) {
	const { inputRef, placeholder, type, input, meta, ...other } = props;

	const { onChange, ...rest } = input || {};

	const { touched, error } = meta || {};

	return (
		<span className="form__form-group-input-wrap">
			<NumberFormat
				{...other}
				{...rest}
				getInputRef={inputRef}
				placeholder={placeholder}
				type={type}
				onValueChange={values => onChange && onChange(values.floatValue)}
			/>
			{((touched && error) || props.errors) && (
				<span className="form__form-group-error">{error || props.errors}</span>
			)}
		</span>
	);
}
export const Phone = props => (
	<NumberFormatCustom {...props} format="(##) #####-####" />
);

export const CPF = props => (
	<NumberFormatCustom {...props} format="###.###.###-##" />
);

function maskCpf(value) {
	const v = String(value == null ? "" : value)
		.replace(/[^0-9]/g, "")
		.slice(0, 11);
	let out = v.slice(0, 3);
	if (v.length > 3) out += "." + v.slice(3, 6);
	if (v.length > 6) out += "." + v.slice(6, 9);
	if (v.length > 9) out += "-" + v.slice(9, 11);
	return out;
}

export const CNPJ = props => {
	const {
		input,
		meta,
		placeholder,
		errors,
		displayType,
		value,
		type,
		...other
	} = props;

	const rawValue = input && input.value != null ? input.value : value;
	const masked = maskCnpjAlfanumerico(rawValue);

	if (displayType === "text") {
		return <span>{masked}</span>;
	}

	const { onChange, onBlur, onFocus, name } = input || {};
	const { touched, error } = meta || {};

	return (
		<span className="form__form-group-input-wrap">
			<input
				{...other}
				name={name}
				type="text"
				inputMode="text"
				placeholder={placeholder}
				value={masked}
				onChange={e =>
					onChange && onChange(cleanCpfCnpj(e.target.value).slice(0, 14))
				}
				onBlur={() => onBlur && onBlur(cleanCpfCnpj(rawValue).slice(0, 14))}
				onFocus={onFocus}
			/>
			{((touched && error) || errors) && (
				<span className="form__form-group-error">{error || errors}</span>
			)}
		</span>
	);
};

export const CPFCNPJ = props => {
	const {
		input,
		meta,
		placeholder,
		errors,
		displayType,
		value,
		type,
		...other
	} = props;

	const rawValue = input && input.value != null ? input.value : value;
	const cleaned = cleanCpfCnpj(rawValue);
	const isCnpj = /[A-Z]/.test(cleaned) || cleaned.length > 11;
	const masked = isCnpj ? maskCnpjAlfanumerico(cleaned) : maskCpf(cleaned);

	if (displayType === "text") {
		return <span>{masked}</span>;
	}

	const { onChange, onBlur, onFocus, name } = input || {};
	const { touched, error } = meta || {};

	const normalize = raw => {
		const alnum = cleanCpfCnpj(raw);
		return /[A-Z]/.test(alnum) || alnum.length > 11
			? alnum.slice(0, 14)
			: alnum.replace(/[^0-9]/g, "").slice(0, 11);
	};

	return (
		<span className="form__form-group-input-wrap">
			<input
				{...other}
				name={name}
				type="text"
				inputMode="text"
				placeholder={placeholder}
				value={masked}
				onChange={e => onChange && onChange(normalize(e.target.value))}
				onBlur={() => onBlur && onBlur(normalize(rawValue))}
				onFocus={onFocus}
			/>
			{((touched && error) || errors) && (
				<span className="form__form-group-error">{error || errors}</span>
			)}
		</span>
	);
};

export const IE = props => (
	<NumberFormatCustom {...props} format="###.###.###" />
);

export const CEP = props => (
	<NumberFormatCustom {...props} format="#####-###" />
);

export const PHONE = props => {
	return <NumberFormatCustom {...props} format="(##) ####-#####" />;
};

export const MONEY = props => {
	return (
		<NumberFormatCustomFloat
			prefix={"R$ "}
			decimalSeparator=","
			thousandSeparator="."
			decimalScale={2}
			fixedDecimalScale
			{...props}
		/>
	);
};

export const PERCENTAGE = props => {
	return (
		<NumberFormatCustomFloat
			suffix={"%"}
			decimalSeparator=","
			thousandSeparator="."
			decimalScale={1}
			fixedDecimalScale
			{...props}
		/>
	);
};

export const PERCENTAGE2 = props => {
	return (
		<NumberFormatCustomFloat
			suffix={"%"}
			decimalSeparator=","
			thousandSeparator="."
			decimalScale={2}
			fixedDecimalScale
			{...props}
		/>
	);
};

export const DATE = props => (
	<NumberFormatCustom {...props} format="##/##/####" />
);

export const DATETIME = props => (
	<NumberFormatCustom {...props} format="##/##/#### ##:##" />
);
